module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAALVBMVEXFLg9HcEzGLQ/FLg7FLQ7cAADILg/GLg/FLg/FLg/FLg/HKxLGLg/GLg7GLg/6yiwPAAAAD3RSTlP/AD/pwAEkiMdU2BTTomaQHa8IAAAAnklEQVQY02MQBIKgEgNmd1UQiwGIJRcwAAHXRAhXrIEBDDgSwVxlBigwAnGFGOBAEchNRnDNgNwGBJdDkEGSAQlMZIgCUWoOEO5SBgUQJSh0AMxlYigAc0XjDEA0OwNYGdA920E0C4MBlCu4F0gzQ4wAcQUV4BYguDDFohDFaEZBLBKEWYTmDDRHonkBzYPo3kcLHLSgQw9YtGBHjhQAhmYcp2QhMZYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/old_age_education/lesson-icon2.png
// module id = WBpC
// module chunks = 1